<template>
    <el-dialog title="煤种数据详情" style="text-align:center" :visible="visible" :show="show" width="80%" :close-on-click-modal="false"
               @close="close">
        <el-form class="detail-form-content" ref="ruleForm" :model="ruleForm" :rules="rules" label-width="140px">
            <el-row>
                <el-col :span="8">
                    <el-form-item label="煤矿名称" class="input" prop="cocalName" >
                        <el-input v-model="ruleForm.cocalName" autocomplete="off" placeholder="煤炭名称" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="煤种类型" class="input" prop="cocalType" >
                        <el-select v-model="ruleForm.cocalType" style="width:100%" disabled>
                            <el-option v-for="(item,i) in cocalTypeList" :label="item.indexName" :key="i" :value="item.indexName"></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基低发热量" class="input" prop="hots" >
                        <el-input v-model.number="ruleForm.hots" autocomplete="off" placeholder="热值" style="width:90%" disabled></el-input>大卡
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="采购价（含税）" class="input" prop="unitPrice" >
                        <el-input v-model="ruleForm.unitPrice" autocomplete="off" placeholder="采购价（含税）" style="width:90%" disabled></el-input>元/吨
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="采购价（不含税）" class="input" prop="bhsUnitPrice" >
                        <el-input v-model="ruleForm.bhsUnitPrice" autocomplete="off" placeholder="不采购价（含税）"  style="width:90%" disabled></el-input>元/吨
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="硫分" class="input" prop="liufen" >
                        <el-input v-model.number="ruleForm.liufen" autocomplete="off" placeholder="请输入..." style="width:90%" disabled></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="到场地" class="input" prop="arriveStation" >
                        <el-input v-model.number="ruleForm.arriveStation" autocomplete="off" placeholder="请输入..." style="width:90%" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基灰分" class="input" prop="sdjhScore" >
                        <el-input v-model="ruleForm.sdjhScore" autocomplete="off" placeholder="收到基灰分" style="width:90%" disabled></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="不含税运费" class="input" prop="bhsPrice" >
                        <el-input v-model.number="ruleForm.bhsPrice" autocomplete="off" placeholder="不含税运费"  disabled ></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="含税运费" class="input" prop="hsPrice" >
                        <el-input v-model.number="ruleForm.hsPrice" autocomplete="off" placeholder="含税运费"   disabled></el-input>
                    </el-form-item>
                </el-col>


                <el-col :span="8">
                    <el-form-item label="全水分" class="input" prop="quanshui" >
                        <el-input v-model="ruleForm.quanshui" autocomplete="off" placeholder="全水分" style="width:90%" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="库存（吨）" class="input" prop="stock" >
                        <el-input v-model.number="ruleForm.stock" autocomplete="off" placeholder="库存" disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="收到基挥发分" class="input" prop="kqgzjhfScore" >
                        <el-input v-model="ruleForm.kqgzjhfScore" autocomplete="off" placeholder="收到基挥发分" style="width:90%" disabled></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="是否破碎" class="input" prop="isBroken" >
                        <el-input v-model="ruleForm.isBroken"  disabled></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item >
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="空气干燥基固定碳" class="input" prop="kqgzjgdt" >
                        <el-input v-model="ruleForm.kqgzjgdt" autocomplete="off" placeholder="空气干燥基固定碳" style="width:90%" disabled></el-input>%
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="破碎费用" class="input" prop="brokenPrice" >
                        <el-input v-model.number="ruleForm.brokenPrice" autocomplete="off" placeholder="破碎费用" :disabled="ruleForm.isBroken=='否'" style="width:90%" disabled ></el-input>  元
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="降热值" class="input" prop="fallHots" >
                        <el-input v-model.number="ruleForm.fallHots" autocomplete="off" placeholder="降热值" :disabled="ruleForm.isBroken=='否'" style="width:90%" disabled></el-input> 卡
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="焦渣特征" class="input" prop="jztz" >
                        <el-input v-model="ruleForm.jztz" autocomplete="off" placeholder="焦渣特征" disabled></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="煤矿联系人" class="input" prop="personName1" >
                        <el-input v-model="ruleForm.personName1" autocomplete="off" placeholder="煤矿联系人" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="提煤联系人1" class="input" prop="personName3" >
                        <el-input v-model="ruleForm.personName3" autocomplete="off" placeholder="提煤联系人" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="提煤联系人2" class="input" prop="personName2" >
                        <el-input v-model="ruleForm.personName2" autocomplete="off" placeholder="联系人" disabled />
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row>
                <el-col :span="8">
                    <el-form-item label="煤矿联系人电话" class="input" prop="mobile1" >
                        <el-input v-model="ruleForm.mobile1" autocomplete="off" placeholder="煤矿联系人电话" disabled></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="8">
                    <el-form-item label="提煤联系人电话1" class="input" prop="mobile3" >
                        <el-input v-model="ruleForm.mobile3" autocomplete="off" placeholder="提煤联系人电话" disabled />
                    </el-form-item>
                </el-col>
                <el-col :span="8">
                    <el-form-item label="提煤联系人电话2" class="input" prop="phone2" >
                        <el-input v-model="ruleForm.phone2" autocomplete="off" placeholder="提煤联系人电话2" disabled />
                    </el-form-item>
                </el-col>
            </el-row>

            <div style="display: flex;flex-wrap: wrap;width: 100%;justify-content: center;">
<!--                <el-button class="btn" type="primary" v-show="updateBtn" @click="commit()">保存</el-button>-->
                <el-button class="btn close" @click="close()">取消</el-button>
            </div>
        </el-form>
    </el-dialog>
</template>
<script>
    import base from '../../../utils/base'
    export default{
        name:'cocalRankingDetail',
        props:{
            show: {
                type: Boolean,
                default: false
            },
            rowData: {
                type: Object,
                default: function(){
                    return {};
                },
            },
        },
        watch:{
            show(){
                this.visible = this.show;
                if(this.show){
                    window.vm = this;
                    this.initCocalTypeList();
                    this.ruleForm.brokenPrice = '0';
                    this.orgType = this.$storage.get("orgType");
                }
            },
            rowData(){
                this.ruleForm = this.rowData;
                if (this.rowData.type=='info'){
                    this.updateBtn = false;
                }
            },
        },
        data(){
            return{
                orgType:'',
                updateBtn:true,
                url:base.get().url,
                visible:false,
                ruleForm:{
                    //必填项
                    cocalName:'',
                    personName:'',
                    mobile:'',
                    cocalType:'',
                    hots:'',
                    liufen:'',
                    unitPrice:'',
                    isBroken:'',
                    stock:'',
                    arriveStation:'',
                    hsPrice:'',
                    stationPrice:'',
                    //非必填
                    quanshui:'',
                    sdjhScore:'',
                    jztz:'',
                    kqgzjhfScore:'',
                    brokenPrice:'0',
                },
                rules:{},
                cocalTypeList:[],
            }
        },
        methods:{
            validateBrokenPrice(rule, value, callback){
                if (this.ruleForm.isBroken=='是' && this.ruleForm.brokenPrice==''){
                    callback(new Error('请输入破碎费用'));
                }else if(this.ruleForm.isBroken=='是' && (isNaN(this.ruleForm.brokenPrice) || this.ruleForm.brokenPrice=='0')){
                    this.ruleForm.brokenPrice = '';
                    callback(new Error('输入破碎费用参数异常'));
                }else if(this.ruleForm.isBroken=='否'){
                    this.ruleForm.brokenPrice = '0';
                    callback();
                }else{
                    callback();
                }
            },
            close(){
                this.updateBtn = true;
                this.$refs['ruleForm'].resetFields();
                this.$emit("listenToChildEvent",false);
            },


            initCocalTypeList(){
                let params = {
                    page: 1,
                    limit: 30,
                    sort: 'id',
                }
                params['dicCode'] = "cocal_type"//编码名字
                params['dicName'] = "煤种类型",//汉字名字
                this.$http({
                    url: "dictionary/page",
                    method: "get",
                    params: params
                }).then(({ data }) => {
                    if (data && data.code === 0) {
                        this.cocalTypeList = data.data.list;
                    }
                });
            }

        }
    }
</script>
<style lang="scss">
    .el-dialog__header {
        background: linear-gradient(135deg, var(--publicMainColor) 0%, #2b5797 100%);
        padding: 16px 20px;
        border-radius: 4px 4px 0 0;
    }
    .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-weight: 600;
    }
    .el-dialog__headerbtn .el-dialog__close {
        color: rgba(255, 255, 255, 0.8);
    }
    .el-dialog__headerbtn .el-dialog__close:hover {
        color: #fff;
    }
    .el-form-item__label {
        font-weight: 600;
        color: #303133;
    }
</style>